import { render } from "./ContentTab.vue?vue&type=template&id=0f1d3054&scoped=true"
import script from "./ContentTab.vue?vue&type=script&lang=js"
export * from "./ContentTab.vue?vue&type=script&lang=js"

import "./ContentTab.vue?vue&type=style&index=0&id=0f1d3054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1d3054"]])

export default __exports__